import Warning from "Components/Elements/Icons/Warning";
import Config from "Configs";
import React from "react";

import Wallet, { IWallet } from "Stores/Wallet";

import classes from "./classes.module.scss";

type IProps = {};
type IState = {
	walletData: IWallet | null;
	showing: boolean;
};
export default class WrongChain extends React.Component<IProps, IState> {
	public state: IState = {
		walletData: null,
		showing: false,
	};

	constructor(props: IProps) {
		super(props);
		const walletData = Wallet.getInstance().walletData;
		this.state = {
			walletData,
			showing: this.isUserConnected(walletData) && !this.isOnRightChain(walletData),
		};
	}

	public render(): JSX.Element {
		return (
			<div className={classes["root"]} data-visible={this.state.showing.toString()}>
				<div className={classes["root-container"]}>
					<div className={classes["warning-container"]}>
						<Warning />
					</div>
					<p className={classes["wrongchain-text"]}>
						You are not connected to the right blockchain. Please connect to the ethereum blockchain to get
						connected.
					</p>
				</div>
			</div>
		);
	}

	public componentDidMount() {
		this.removeOnChange = Wallet.getInstance().onChange((walletData) => this.onUserConnect(walletData));
	}

	public componentWillUnmount() {
		this.removeOnChange();
	}

	private onUserConnect(walletData: IWallet) {
		this.setState({ walletData, showing: this.isUserConnected(walletData) && !this.isOnRightChain(walletData) });
	}

	private removeOnChange = () => {};

	private isOnRightChain(walletData: IWallet | null): boolean {
		const rightChain = Config.getInstance().get().wallet.chainId;
		const actualChain = walletData?.chainId;

		return rightChain === actualChain;
	}

	private isUserConnected(walletData: IWallet | null) {
		return !!walletData?.userAddress;
	}
}
